"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function doesObjHaveUndefinedValues(obj) {
    return ((0, lodash_1.map)(obj, function (value) {
        return value === undefined ? null : value;
    }).filter(function (x) { return x === null; }).length !== 0);
}
exports.default = doesObjHaveUndefinedValues;
